import { render } from "./FavStar.vue?vue&type=template&id=31d9d670"
import script from "./FavStar.vue?vue&type=script&lang=js"
export * from "./FavStar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__